<template>
  <div class="col-xs-12">
    <p>We do not have any data for this milestone.</p>
  </div>
</template>

<script>
export default {
  name: 'MilestoneNoDataAvailable'
}
</script>
